import { createAction } from '@ngrx/store';

export const actionToggleHide = createAction('[Measurement] Toggle Hide');
